import { isAutodeskBuildIntegrationBranding } from './autodeskBuildIntegration'

type UnifierBranding = {
  sendButtonLabel: string
  successToast: (entityLabel: string) => string
  defaultFailureToast: (entityLabelLower: string) => string
  modalTitle: string
  /** Shown after “to” in the confirmation sentence, e.g. “…to Oracle Primavera Unifier?” */
  confirmDestinationName: string
}

type ProcoreUiBranding = {
  contextMenuNewRfi: string
  contextMenuLinkExistingRfi: string
  contextMenuSaveImage: string
  newRfiFormTitle: string
  linkExistingRfiFormTitle: string
  createdRfiTitlePrefix: string
  buildingsCardLinkProject: string
  buildingsProjectLinkModalTitle: (buildingName: string) => string
}

type IntegrationBranding = {
  unifier: UnifierBranding
  procore: ProcoreUiBranding
}

const autodeskBuild: IntegrationBranding = {
  unifier: {
    sendButtonLabel: 'Send to Build',
    successToast: entityLabel =>
      `${entityLabel} sent to Autodesk Build successfully.`,
    defaultFailureToast: entityLabelLower =>
      `Failed to send ${entityLabelLower} to Autodesk Build. Please try again.`,
    modalTitle: 'Send to Autodesk Build',
    confirmDestinationName: 'Autodesk Build',
  },
  procore: {
    contextMenuNewRfi: 'New Build RFI',
    contextMenuLinkExistingRfi: 'Link Existing Build RFI',
    contextMenuSaveImage: 'Save Image to Autodesk Build',
    newRfiFormTitle: 'New Autodesk Build RFI',
    linkExistingRfiFormTitle: 'Select Existing Autodesk Build RFI',
    createdRfiTitlePrefix: 'Autodesk Build RFI',
    buildingsCardLinkProject: 'Link Project With Autodesk Build',
    buildingsProjectLinkModalTitle: buildingName =>
      `Autodesk Build Project Link - ${buildingName}`,
  },
}

const legacy: IntegrationBranding = {
  unifier: {
    sendButtonLabel: 'Send to Unifier',
    successToast: entityLabel => `${entityLabel} sent to Unifier successfully.`,
    defaultFailureToast: entityLabelLower =>
      `Failed to send ${entityLabelLower} to Unifier. Please try again.`,
    modalTitle: 'Send to Oracle Primavera Unifier',
    confirmDestinationName: 'Oracle Primavera Unifier',
  },
  procore: {
    contextMenuNewRfi: 'New RFI',
    contextMenuLinkExistingRfi: 'Link Existing RFI',
    contextMenuSaveImage: 'Save Image to Procore',
    newRfiFormTitle: 'New Procore RFI',
    linkExistingRfiFormTitle: 'Select Existing Procore RFI',
    createdRfiTitlePrefix: 'Procore RFI',
    buildingsCardLinkProject: 'Link Project With Procore',
    buildingsProjectLinkModalTitle: buildingName =>
      `Procore Project Link - ${buildingName}`,
  },
}

export const integrationBranding: IntegrationBranding =
  isAutodeskBuildIntegrationBranding ? autodeskBuild : legacy
